export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-comments-d4cca2fc52f79e7c66983fdca55d1b3f.svg";